// extracted by mini-css-extract-plugin
export default {"page":"preload-generator_page__uy7J3"};